import type { JSX } from "react";

/**
 * Reusable confirmation dialog for sensitive operations (delete account, reset
 * password, …). Sensitive actions must be confirmed before they run. Styling
 * uses the Cycle design-system tokens; the destructive variant uses the
 * `--color-error` token for the confirm button.
 */
export function ConfirmDialog({
  title,
  message,
  confirmLabel,
  cancelLabel = "取消",
  destructive = false,
  busy = false,
  onConfirm,
  onCancel
}: {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel?: string;
  destructive?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}): JSX.Element {
  return (
    <div className="admin-overlay confirm-overlay" onClick={onCancel}>
      <div className="confirm-card" onClick={(e) => e.stopPropagation()}>
        <h2 className="confirm-title">{title}</h2>
        <p className="confirm-message">{message}</p>
        <div className="confirm-actions">
          <button className="confirm-btn-cancel" type="button" onClick={onCancel} disabled={busy}>
            {cancelLabel}
          </button>
          <button
            className={destructive ? "confirm-btn-danger" : "confirm-btn-primary"}
            type="button"
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? "处理中…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
